import { render, staticRenderFns } from "./PendencyService.vue?vue&type=template&id=3732d815&scoped=true&"
import script from "./PendencyService.vue?vue&type=script&lang=js&"
export * from "./PendencyService.vue?vue&type=script&lang=js&"
import style0 from "./PendencyService.vue?vue&type=style&index=0&id=3732d815&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3732d815",
  null
  
)

export default component.exports